import { LitElement, html, css, utils } from '@hh/global.js'

const { setCookie, getCookie } = utils

class HHNewsletterPopup extends LitElement {
  static properties = {
    open: {
      type: Boolean,
      reflect: true,
    },
    id: {
      type: String,
    },
    delay: {
      type: String,
    },
  }

  constructor() {
    super()

    this.delay = this.dataset.delay * 1000
    this.closed = getCookie('newsletter-closed')
    this.subscribed = getCookie('newsletter-subscribed')
  }

  connectedCallback() {
    super.connectedCallback()

    this.addEventHandlers()

    if (this.dataset.openInDesignMode === 'true') {
      return
    }

    setTimeout(() => {
      if (this.closed !== null || this.subscribed !== null) return

      this.show()
    }, this.delay)
  }

  addEventHandlers() {
    if (this.dataset.openInDesignMode === 'true') {
      document.addEventListener('shopify:section:select', (event) => {
        if (event.target.contains(this)) {
          this.show()
        }
      })

      document.addEventListener('shopify:section:deselect', (event) => {
        this.hide()
      })
    }

    window.addEventListener('klaviyoForms', (event) => {
      if (event.detail.type == 'submit') {
        this.onSubscribe()
      }
    })
  }

  hide() {
    this.open = false

    setCookie('newsletter-closed', 'true')
  }

  show() {
    this.open = true
  }

  onSubscribe() {
    setCookie('newsletter-subscribed', 'true', 365)
  }

  render() {
    return html`
      <div class="newsletter-popup__inner">
        <slot name="close" @click=${this.hide}></slot>

        <slot name="form"></slot>
      </div>

      <slot name="overlay" @click=${this.hide}></slot>
    `
  }

  static styles = css`
    .newsletter-popup__inner {
      position: fixed;
      bottom: 0;
      z-index: 5;
      background-color: var(--hh-color-brand-primary);
      max-width: 87.6rem;
      width: calc(100% - 4rem);
      padding: 1.3rem 2rem;
      margin-bottom: 0;
    }

    @media screen and (min-width: 750px) {
      .newsletter-popup__inner {
        position: relative;
        padding: 2rem;
        margin-bottom: 10.2rem;
      }
    }
  `
}

customElements.define('hh-newsletter-popup', HHNewsletterPopup)
